<div class="modal-header">
  <div class="modal-branding-content">
    <span class="modal-header-branding-text">Download the Latest Electrical Standards</span>
  </div>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body py-2">
  <div class="container">
    <div class="row mb-3">
      <div class="col-12">
        <div class="input-group">
          <input
            type="text"
            class="form-control m-input"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            name="searchTerm"
            (ngModelChange)="onSearchTermChanged()"
            (keyup.enter)="loadStandards(true)"
          />
          <span class="input-group-btn">
            <button class="btn btn-primary" type="button" (click)="loadStandards(true)" [disabled]="searchLoading || isLoading">
              <i class="flaticon-search-1" *ngIf="!(searchLoading || isLoading)" aria-label="Search"></i>
              <i class="fa fa-spinner fa-spin" *ngIf="searchLoading || isLoading"></i>
            </button>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading && standards.length === 0" class="text-center py-4">
      <i class="fa fa-spinner fa-spin me-2"></i>
      <span class="ms-2">Loading...</span>
    </div>

    <div *ngIf="!isLoading && hasError" class="alert alert-danger mt-2">
      {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && !hasError && standards.length === 0" class="text-muted text-center py-4">
      No standards found.
    </div>

    <div *ngIf="standards.length > 0">
      <div *ngFor="let standard of standards" class="standard-item">
        <div class="standard-item__row">
          <div class="standard-item__content">
            <div class="standard-item__title-line">
              <strong class="standard-item__title">{{ standard.title }}</strong>
              <span *ngIf="getStatusLabel(standard.statusTag) as statusLabel"
                    class="status-tag"
                    [ngClass]="getStatusTagClass(standard.statusTag)">
                {{ statusLabel }}
              </span>
            </div>
            <p class="standard-item__description text-muted" *ngIf="standard.description">
              {{ standard.description }}
            </p>
          </div>

          <div class="standard-item__actions">
            <a href="javascript:void(0)"
               (click)="getStandardUrl(standard.id)"
               rel="noopener noreferrer"
               class="standard-item__link text-decoration-none fw-semibold"
               [class.is-loading]="openingId === standard.id">
              <i class="fa fa-file-pdf-o me-1" *ngIf="openingId !== standard.id"></i>
              <i class="fa fa-spinner fa-spin me-1" *ngIf="openingId === standard.id"></i>
              View PDF
            </a>
          </div>
        </div>
      </div>

      <div class="text-center py-3" *ngIf="canLoadMore">
        <button class="btn btn-outline-primary" type="button" (click)="loadMoreStandards()" [disabled]="searchLoading || isLoading">
          <span *ngIf="!searchLoading && !isLoading">Load More</span>
          <span *ngIf="searchLoading || isLoading">
            <i class="fa fa-spinner fa-spin"></i> {{ searchLoading ? 'Searching' : 'Loading' }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
